import React from 'react';
import Select from '../../../common/Select.jsx';
import styles from '../base/CommonSettings.module.scss';

function MapWidgetContentSettingsRow({index, widgetId, settingDatasourceOptions, additionalFields, updateAdditionalField}){
  const {field_label, field_value} = additionalFields[index];

  return (
    <div className={styles['settings-option']} >
      <label>
        {I18n.t("label")}
        <input
            type="text"
            className="form-control"
            name="field_label"
            value={field_label}
            onChange={(e) => updateAdditionalField("field_label", index, e.target.value)}
        />
      </label>

      <label>
          {I18n.t("datasource")}
          <Select
            options={settingDatasourceOptions}
            value={field_value}
            placeholder={I18n.t("select_from_list")}
            onChange={(v) => updateAdditionalField("field_value", index, v)}
          />
      </label>
    </div>
  )
}

export default MapWidgetContentSettingsRow;
